<h1 mat-dialog-title>Add Patron Error</h1>
<mat-dialog-content>
  <p>The following patron cannot place a hold:</p>
  <p>{{ name }}</p>
  <ul style="list-style-type: disc; padding-left: 20px">
    <li *ngFor="let message of messages">{{ message }}</li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">OK</button>
</mat-dialog-actions>
